import { Directive } from '@angular/core';
import {
   LcsChipMultiSelectTextContentFn,
   LcsChipMultiSelectTriggerComponent,
} from 'src/app/common-components/multi-select/chip-multi-select-trigger.component';
import { PhoneNumberOption } from '../models/phone-number-option';

@Directive({
    selector: 'lcs-chip-multi-select-trigger[ndtPhoneNumberMultiSelect]',
    standalone: false
})
export class PhoneNumberChipMultiSelectTriggerDirective {
   constructor(trigger: LcsChipMultiSelectTriggerComponent<PhoneNumberOption>) {
      trigger.getDisplayText = entityChipMultiSelectText(trigger);
   }
}

export function entityChipMultiSelectText<T = PhoneNumberOption>(
   _multiSelect: LcsChipMultiSelectTriggerComponent<PhoneNumberOption>
): LcsChipMultiSelectTextContentFn<PhoneNumberOption> {
   return (item: PhoneNumberOption | null | undefined): string => {
      return `${item?.phoneNumber}`;
   };
}
